import colors from "../../../Constants/colors";

export const templateContainerStyles = {
  display: "flex",
  bgcolor: colors.extremeBlue,
  flexDirection: "column",
  width: { xs: "90%", md: "96%" },
  minWidth: { xs: "90%", md: "96%" },
  height: "100vh",
  color: colors.extremeWhite,
  overflowY: "hidden",
  padding: "10px 0px",
};

export const templatePaperStyles = {
  display: "flex",
  flexDirection: "column",
  width: { xs: "97%", md: "100%" },
  backgroundColor: colors.extremeBlue,
  my: "10px",
  padding: 0,
  height: { xs: "100vh", md: "90vh" },
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
  scrollbarWidth: "thin",
  scrollbarColor: colors.secondaryBlue,
  "&::-webkit-scrollbar": {
    width: "12px",
    height: "12px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: colors.secondaryBlue,
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: colors.primaryBlue,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: colors.secondaryBlue,
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
};

export const btnStyles = {
  color: colors.extremeWhite,
  bgcolor: colors.primaryBlue,
  ":hover": { bgcolor: colors.secondaryBlue },
  textTransform: "none !important",
  "&.Mui-disabled": {
    color: colors.lightGray,
    bgcolor: colors.secondaryBlue,
  },
  mb: 1,
};

export const templateCardStyles = {
  flex: {
    xs: "1 1 100%", // 1 column on extra-small screens
    sm: "1 1 calc(50% - 16px)", // 2 columns on small screens
    md: "1 1 calc(33.33% - 16px)", // 3 columns on medium and larger screens
  },
  maxWidth: {
    xs: "100%", // Full width on extra-small screens
    sm: "calc(50% - 16px)", // Half width on small screens
    md: "calc(33.33% - 16px)", // Third width on medium and larger screens
  },
  boxSizing: "border-box",
  borderRadius: 2,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.6)",
    transform: "scale(1.05)",
  },
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  background: "linear-gradient(135deg, #3A3A5A  20%, #1e2732 100%)",
  color: colors.extremeWhite,
};

export const dashboarStyles = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  height: "100%",
  overflowY: "hidden",
};

export const dashboarStylesButton = {
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
};

export const contentGenerationOnly = {
  borderBottom: `1px solid ${colors.extremeWhite}`,
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "flex-start",
  alignItems: "center",
  padding: "40px 0px",
  marginBottom: "30px",
};

export const loaderStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  position: "relative",
  color: colors.bgLight,
  "& .loader_": {
    border: `4px solid ${colors.colorLight}`, // Light gray
    borderTop: `4px solid ${colors.extremeBlue}`, // Blue color
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    animation: "spin 1s linear infinite",
  },
  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
};
